import { render, staticRenderFns } from "./sessionlist.vue?vue&type=template&id=44a94454&"
import script from "./sessionlist.vue?vue&type=script&lang=ts&"
export * from "./sessionlist.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/Rnwood.Smtp4dev/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44a94454')) {
      api.createRecord('44a94454', component.options)
    } else {
      api.reload('44a94454', component.options)
    }
    module.hot.accept("./sessionlist.vue?vue&type=template&id=44a94454&", function () {
      api.rerender('44a94454', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sessionlist.vue"
export default component.exports